import React, { forwardRef, useState, useEffect } from "react";
import ThermalPrintHeader from "../../print/ThermalPrintHeader";

const SalesThermalPrint = forwardRef(({ salesRecord }, ref) => {
  const [salesDetails, setSalesDetails] = useState(salesRecord[0]);

  return (
    <div ref={ref} style={{ width: "80mm", fontSize: "15px" }}>
      <ThermalPrintHeader />
      {/* <div style={{ textAlign: "center" }}>
        <p style={{ fontSize: "14px", fontWeight: 900, paddingLeft:"50px" }}>
          MAR & SONS FISH COMPANY
        </p>
        <p style={{ fontSize: "14px", fontWeight: 900, paddingLeft:"50px" }}>
          ShopNo:7 Sandhaipettai Fish Market
        </p>
        <p style={{ fontSize: "14px", fontWeight: 900, paddingLeft:"50px" }}>
          Thennampalayam, Tirupur 641 604.
        </p>
        <p style={{ fontSize: "14px", fontWeight: 900, paddingLeft:"50px" }}>
          9952624050, 9500591327, 9894777656
        </p>
      </div> */}
      <p style={{ textAlign: "center", fontWeight: 900, paddingLeft: "50px" }}>
        Sales Registry
      </p>
      <table
        style={{
          marginTop: "10px",
          lineHeight: "1.5em",
          width: "100%",
        }}
      >
        <tbody>
          <tr>
            <td
              style={{
                fontSize: "14px",
                fontWeight: "bold",
                width: "25%",
                paddingLeft: "15px",
              }}
            >
              பில்எண்
            </td>
            <td
              style={{
                fontSize: "14px",
                width: "25%",
                fontWeight: "bold",
                whiteSpace: "nowrap",
                paddingLeft: "15px",
              }}
            >
              {": " + salesDetails.SalesNo}
            </td>
            <td
              style={{
                fontSize: "14px",
                fontWeight: "bold",
                width: "25%",
                paddingLeft: "15px",
              }}
            >
              தேதி
            </td>
            <td
              style={{
                fontSize: "14px",
                width: "25%",
                fontWeight: "bold",
                whiteSpace: "nowrap",
                paddingLeft: "15px",
              }}
            >
              {": " + salesDetails.SalesDate}
            </td>
          </tr>
          <tr>
            <td
              style={{
                fontSize: "14px",
                fontWeight: "bold",
                width: "25%",
                paddingLeft: "15px",
              }}
            >
              குறியீடு
            </td>
            <td
              style={{
                fontSize: "14px",
                width: "25%",
                fontWeight: "bold",
                whiteSpace: "nowrap",
                paddingLeft: "15px",
              }}
            >
              {": " + salesDetails.CUCode}
            </td>
            <td
              style={{
                fontSize: "14px",
                fontWeight: "bold",
                width: "25%",
                paddingLeft: "15px",
              }}
            >
              பெயர்
            </td>
            <td
              style={{
                fontSize: "14px",
                width: "25%",
                fontWeight: "bold",
                whiteSpace: "nowrap",
                paddingLeft: "15px",
              }}
            >
              {": " + salesDetails.CUName}
            </td>
          </tr>
        </tbody>
      </table>
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
        }}
      >
        <thead>
          <tr>
            <th
              style={{
                border: "1px dashed",
                padding: "4px",
                fontWeight: 900,
                width: "25%",
                paddingLeft: "15px",
              }}
            >
              பொருள்
            </th>
            <th
              style={{
                border: "1px dashed",
                padding: "4px",
                fontWeight: 900,
                width: "25%",
              }}
            >
              அளவு
            </th>
            <th
              style={{
                border: "1px dashed",
                padding: "4px",
                fontWeight: 900,
                width: "25%",
              }}
            >
              விலை
            </th>
            <th
              style={{
                border: "1px dashed",
                padding: "4px",
                fontWeight: 900,
                width: "25%",
              }}
            >
              மொ.தொகை
            </th>
          </tr>
        </thead>
        <tbody>
          {salesDetails?.Items?.length > 0 ? (
            salesDetails.Items.map((item, index) => (
              <tr key={index}>
                <td
                  style={{
                    border: "1px dashed",
                    padding: "4px",
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: "14px",
                    whiteSpace: "nowrap",
                  }}
                >
                  {item.IName}
                </td>
                <td
                  style={{
                    border: "1px dashed",
                    padding: "4px",
                    fontWeight: "bold",
                    textAlign: "left",
                    fontSize: "14px",
                    whiteSpace: "nowrap", // Prevent wrapping
                  }}
                >
                  {item.Quantity + " " + item.UName}
                </td>
                <td
                  style={{
                    border: "1px dashed",
                    padding: "4px",
                    fontWeight: "bold",
                    textAlign: "right",
                    fontSize: "14px",
                    whiteSpace: "nowrap",
                  }}
                >
                  {item.UnitPrice}
                </td>
                <td
                  style={{
                    border: "1px dashed",
                    padding: "4px",
                    fontWeight: "bold",
                    textAlign: "right",
                    fontSize: "14px",
                    whiteSpace: "nowrap",
                  }}
                >
                  {item.TotalAmount}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan="4"
                style={{
                  textAlign: "center",
                  padding: "4px",
                  fontWeight: "bold",
                }}
              >
                No items available
              </td>
            </tr>
          )}
          {/* Add a new row for total quantities */}
          <tr>
            <td style={{ border: "none" }}></td>
            <td
              style={{
                border: "none",
                padding: "4px",
                fontWeight: "bold",
                textAlign: "left",
                fontSize: "14px",
                whiteSpace: "nowrap",
              }}
            >
              {salesDetails.TotalQuantityPerKg + " Kg"}
            </td>
            <td style={{ border: "none" }}></td>
            <td style={{ border: "none" }}></td>
          </tr>
          <tr>
            <td style={{ border: "none" }}></td>
            <td
              style={{
                border: "none",
                padding: "4px",
                fontWeight: "bold",
                textAlign: "left",
                fontSize: "14px",
                whiteSpace: "nowrap",
              }}
            >
              {salesDetails.TotalQuantityPerBox + " Box"}
            </td>
            <td style={{ border: "none" }}></td>
            <td style={{ border: "none" }}></td>
          </tr>
        </tbody>
      </table>

      <table
        style={{
          width: "100%",
          marginTop: "10px",
          marginLeft: "43px",
          lineHeight: "1.5em",
        }}
      >
        <tbody>
          <tr>
            <td
              style={{
                width: "70%",
                textAlign: "right",
                fontSize: "14px",
                fontWeight: "bold",
              }}
            >
              தற்போதைய தொகை :
            </td>
            <td
              style={{
                width: "30%",
                textAlign: "right",
                fontSize: "14px",
                fontWeight: "bold",
                paddingLeft: "10px",
              }}
            >
              {salesDetails.CurrentAmount}
            </td>
          </tr>
          <tr>
            <td
              style={{
                width: "70%",
                textAlign: "right",
                fontSize: "14px",
                fontWeight: "bold",
              }}
            >
              பாக்கி தொகை :
            </td>
            <td
              style={{
                width: "30%",
                textAlign: "right",
                fontSize: "14px",
                fontWeight: "bold",
                paddingLeft: "10px",
              }}
            >
              {salesDetails.OpeningBalance}
            </td>
          </tr>
          <tr>
            <td
              style={{
                width: "70%",
                textAlign: "right",
                fontSize: "14px",
                fontWeight: "bold",
              }}
            >
              குறைந்த தொகை :
            </td>
            <td
              style={{
                width: "30%",
                textAlign: "right",
                fontSize: "14px",
                fontWeight: "bold",
                paddingLeft: "10px",
              }}
            >
              {salesDetails.LessAmount}
            </td>
          </tr>
          <tr>
            <td
              style={{
                width: "70%",
                textAlign: "right",
                fontSize: "14px",
                fontWeight: "bold",
              }}
            >
              நிகர தொகை :
            </td>
            <td
              style={{
                width: "30%",
                textAlign: "right",
                fontSize: "14px",
                fontWeight: "bold",
                paddingLeft: "10px",
              }}
            >
              {salesDetails.NetAmount}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
});

export default SalesThermalPrint;
